import script from "./RowActionMenubar.vue?vue&type=script&setup=true&lang=ts"
export * from "./RowActionMenubar.vue?vue&type=script&setup=true&lang=ts"

import "./RowActionMenubar.vue?vue&type=style&index=0&id=f9fb59f2&lang=scss"

const __exports__ = script;

export default __exports__